"use strict";

var _AppHeader, _Aside, _Tenants;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { PageLoading } from '@autoguru/components';
import { Box, Portal } from '@autoguru/overdrive';
import baseTheme from '@autoguru/overdrive/dist/themes/base';
import { AsyncBoundary } from '@autoguru/suspense';
import { lazy } from 'react';
import { Aside } from '~/src/features/aside';
import { AppHeader, pageHeaderPortalId } from '~/src/features/header';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const pageAsidePortalId = '__ag-aside__';
const Tenants = /*#__PURE__*/lazy(async () => import('~/src/views/tenantSelector/Tenants'));
export const App = () => /*#__PURE__*/_jsx(Box, {
  className: [baseTheme.themeRef],
  children: /*#__PURE__*/_jsxs(AsyncBoundary, {
    fallback: PageLoading,
    children: [/*#__PURE__*/_jsx(Portal, {
      container: document.querySelector(`#${pageHeaderPortalId}`),
      children: _AppHeader || (_AppHeader = /*#__PURE__*/_jsx(AppHeader, {}))
    }), /*#__PURE__*/_jsx(Portal, {
      noThemedWrapper: true,
      container: document.querySelector(`#${pageAsidePortalId}`),
      children: _Aside || (_Aside = /*#__PURE__*/_jsx(Aside, {}))
    }), _Tenants || (_Tenants = /*#__PURE__*/_jsx(Tenants, {}))]
  })
});